import { render } from "./updatetable.vue?vue&type=template&id=4eedaef7"
import script from "./updatetable.vue?vue&type=script&lang=js"
export * from "./updatetable.vue?vue&type=script&lang=js"

import "./updatetable.vue?vue&type=style&index=0&id=4eedaef7&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__